
        var result = require("!!../../../../node_modules/css-loader/index.js!./customers-group.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/customers/customers-group.component.css
// module id = 646
// module chunks = 0